import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/main.css";
import ProdusGallery from "../components/ProdusGallery";
import "../css/main.css";

const Produs = () => {
  return (
    <div>
      <Header />

      <div className="produs">
        <div className="container">
          <div className="box">
            <div className="gallery">
              <ProdusGallery />
            </div>
            <div className="content">
              <h1>Caiet personalizat</h1>
              <p>
                Cauți materiale care să te ajute în gestionarea stresului,
                dezvoltarea personală sau îmbunătățirea relațiilor? Aici{" "}
              </p>
              <div className="price">€140.00</div>
              <div className="add-to-cart">
                <a href="/" className="button secondary">
                  Adaugă în coș
                </a>
              </div>
              <div className="buy-now">
                <a href="/" className="button primary">
                  Cumpără acum
                </a>
              </div>
              <div className="specs">
                <h2>Specificatii:</h2>
                <ul>
                  <li>
                    <label>Dimensiune:</label>
                    <div className="value">12x20x40</div>
                  </li>
                  <li>
                    <label>Culoare:</label>
                    <div className="value">Crem</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Produs;
